import { render, staticRenderFns } from "./searchHead.vue?vue&type=template&id=2e66156b&scoped=true&"
import script from "./searchHead.vue?vue&type=script&lang=js&"
export * from "./searchHead.vue?vue&type=script&lang=js&"
import style0 from "./searchHead.vue?vue&type=style&index=0&id=2e66156b&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e66156b",
  null
  
)

export default component.exports